(function () {
  'use strict';
  angular.module('app').config($urlRouterProvider => $urlRouterProvider.otherwise('/app/no-found'));
})();
